import Duck from 'extensible-duck';
import Immutable from 'immutable';
import { createSelector } from 'reselect';
import { schema, denormalize } from 'normalizr';

export const albumPhotoSchema = new schema.Entity('$$albumPhotos');
export const albumSchema = new schema.Entity('$$albums', {
  first_photo: albumPhotoSchema,
  album_photos: [albumPhotoSchema],
});

export default new Duck({
  namespace: 'public',
  store: 'album',
  types: [],
  initialState: Immutable.fromJS({
    photoPage: 1,
    pagesLoaded: 1,
    lastPage: null,
    $$entities: {
      $$albums: {},
      $$albumPhotos: {},
    },
    $$albumPhotoIds: [],
    $$albumIds: [],
  }),
  reducer: ($$state, { type, payload, _meta }, { types }) => {
    switch (type) {
      default:
        return $$state;
    }
  },
  selectors: {
    $$allAlbumPhotos: new Duck.Selector(_selectors =>
      createSelector(
        $$state => $$state.getIn(['$$entities', '$$albumPhotos']),
        $$state => $$state.get('$$albumPhotoIds'),
        ($$albumPhotos, $$albumPhotoIds) =>
          $$albumPhotoIds.map(albumPhotoId =>
            $$albumPhotos.get(albumPhotoId.toString())
          )
      )
    ),
    $$albums: new Duck.Selector(_selectors =>
      createSelector(
        $$state => $$state.get('$$entities'),
        $$state => $$state.get('$$albumIds'),
        ($$entities, $$albumIds) =>
          denormalize($$albumIds, [albumSchema], $$entities)
      )
    ),
  },
  creators: ({ types }) => ({}),
});
